<template>
  <div id="container">
    <span class="title">{{blog.title}}</span>
    <el-row class="userInfo">
      <el-avatar :size="30" :src="user.avatarurl" v-if="user.avatarurl"></el-avatar>
      <el-avatar :size="30" :src="require('@/assets/user_icon.jpeg')" v-else></el-avatar>
      <span class="username">{{user.nickname}}</span>
      <span class="time">{{blog.create_at}}</span>
    </el-row>
    <div v-for="(item, index) in blog.blog_desc" :key="index">
      <BlogDetailItem :item="item"></BlogDetailItem>
    </div>

    <div
      style="background: #FAFAFA; height: 6px;margin-top: 16px; margin-left: -12px; margin-right: -12px;"
    ></div>

    <div class="comment_header">
      <span
        style="background: #2497F7; width: 4px; height: 16px; margin-left: -12px; margin-right: 12px;"
      />
      <span style="color: #5C5C5C; font-size: 16px">全部评论（{{blog.commentcount}}）</span>
    </div>

    <div v-for="(comment) in comments" :key="comment.cid">
      <BlogComment :comment="comment"></BlogComment>
    </div>


    <div class="download_view">
      <el-image
          style="width: 50px; height: 50px;"
          :src="require('@/assets/app_icon.png')"
          fit="contain"
          lazy
        />
      <div class="text_view">
        <span class="title">撼高组</span>
        <span class="desc">撼高组血压血糖</span>
      </div>
       <router-link :to="{ name: 'Download'}">
        <el-button type="primary" round size="small">下载APP</el-button>
      </router-link>
    </div>
  </div>
</template>

<script>
// import Api from '@/network/Api';
import BlogDetailItem from "@/components/BlogDetailItem";
import BlogComment from "@/components/BlogComment";

export default {
  name: "Detail",
  components: {
    BlogComment,
    BlogDetailItem
  },
  data() {
    return {
      reviewId: null,
      blog: {},
      user: {},
      comments: []
    };
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.params.id && to.params.id != from.params.id) {
        this.reviewId = to.params.id;
        this.init(); //重新加载数据
      }
    }
  },
  created() {
    console.log(this.$route.params);
    this.reviewId = this.$route.params.id;
    this.init();
  },
  methods: {
    init() {
      this.blog = {};
      this.user = {};
      this.comments = [];
      this.getCommunityDetail(this.reviewId);
      this.getBlogCommentList(this.reviewId);
    },
    async getCommunityDetail(reviewId) {
      if (!reviewId) {
        this.$message.error("参数传递错误");
        return;
      }
      let loadingInstance = this.$loading({
        fullscreen: true,
        text: "加载中...",
        background: "#80000000"
      });
      // let loadingInstance = Loading.service({ fullscreen: true });
      try {
        let ret = await this.$Api.getCommunityDetail(reviewId);
        this.blog = ret.data;
        this.user = ret.data.user;
        loadingInstance.close();
      } catch (error) {
        loadingInstance.close();
      }

      // this.$Api.getCommunityDetail(reviewId,
      //   response => {
      //     console.log(response)
      //    loadingInstance.close();
      //     this.data = response.data
      //     this.user = response.data.user
      //   },
      //   error => {
      //     loadingInstance.close();
      //   })
    },
    async getBlogCommentList(reviewId) {
      let ret = await this.$Api.getBlogCommentList(reviewId);
      this.comments = ret.data.items;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#container {
  padding: 4px;
  background: #ffffff;
  padding-bottom: 40px;
}
.title {
  font-size: 20px;
  color: #000000;
  font-weight: bold;
}
.userInfo {
  display: flex;
  align-items: center;
  margin: 10px 0px;
}
.userInfo .username {
  color: #2598f3;
  font-size: 14px;
  padding: 0px 10px;
}
.userInfo .time {
  color: #b7b8b9;
  font-size: 14px;
  padding-left: 10px;
}

.comment_header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 14px;
  padding-bottom: 14px;
}
.download_view {
  background: rgba(255, 255, 255, 0.8);
  overflow: hidden;
  z-index: 9999;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-right: 10px;
  padding-left: 10px;
}
.download_view .text_view {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-left: 5px;
  padding-right: 5px;
}

.download_view .text_view .title{
  font-size: 14px;
}

.download_view .text_view .desc{
  font-size: 12px;
  padding-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/community/Detail.vue